import { Injectable, inject } from '@angular/core';

import { Actions, createEffect } from '@ngrx/effects';

import { AuthService } from '@views/misc/auth/auth.service';

import * as actions from './notifications.actions';
import { NotificationsService } from './notifications.service';

@Injectable()
export class Effects {
  private actions$ = inject(Actions);
  private notificationsService = inject(NotificationsService);
  private authService = inject(AuthService);

  fetchList$ = createEffect(
    this.authService.createGenericRequest({
      actions$: this.actions$,
      makeRequest: action => this.notificationsService.fetchList(action.payload),
      startAction: actions.notificationsFetchListStart,
      successAction: actions.notificationsFetchListSuccess,
      failAction: actions.notificationsFetchListFail,
    }),
  );

  fetchUnreadCount$ = createEffect(
    this.authService.createGenericRequest({
      actions$: this.actions$,
      makeRequest: () => this.notificationsService.fetchUnreadNotificationsCount(),
      startAction: actions.notificationsFetchUnreadCountStart,
      successAction: actions.notificationsFetchUnreadCountSuccess,
      failAction: actions.notificationsFetchUnreadCountFail,
    }),
  );

  updateItem$ = createEffect(
    this.authService.createGenericRequest({
      actions$: this.actions$,
      makeRequest: action => this.notificationsService.updateItem(action.payload.notificationId),
      startAction: actions.notificationsUpdateItemStart,
      successAction: actions.notificationsUpdateItemSuccess,
      failAction: actions.notificationsUpdateItemFail,
    }),
  );

  updateAll$ = createEffect(() =>
    this.authService.createGenericRequest({
      actions$: this.actions$,
      makeRequest: () => this.notificationsService.updateAll(),
      startAction: actions.notificationsMarkAllAsReadStart,
      successAction: actions.notificationsMarkAllAsReadSuccess,
      failAction: actions.notificationsMarkAllAsReadFail,
    }),
  );
}
